export type AppVersionInfo = {
  versionCode: number;
  versionName: string;
};

export type AppUpdateCheckResult =
  | { status: 'current' }
  | { status: 'unknown'; reason: string }
  | {
      status: 'update_available';
      remote: AppVersionInfo;
      downloadUrl: string | null;
    };

export type RemoteVersionManifest = {
  versionCode: number;
  versionName: string;
  downloadUrl: string | null;
};

export function parseMobileVersionManifest(json: unknown): RemoteVersionManifest | null {
  if (!json || typeof json !== 'object') return null;
  const o = json as Record<string, unknown>;
  const rawCode = o.versionCode ?? o.version_code ?? o.build;
  const code = typeof rawCode === 'number' ? rawCode : Number.parseInt(String(rawCode ?? ''), 10);
  if (!Number.isFinite(code) || code < 1) return null;
  const nameRaw = o.versionName ?? o.version_name ?? o.version;
  const versionName = typeof nameRaw === 'string' && nameRaw.trim() ? nameRaw.trim() : String(code);
  const urlRaw = o.downloadUrl ?? o.download_url ?? o.url;
  const downloadUrl = typeof urlRaw === 'string' && urlRaw.trim() ? urlRaw.trim() : null;
  return { versionCode: code, versionName, downloadUrl };
}

export function isRemoteVersionNewer(remoteCode: number, localCode: number): boolean {
  return remoteCode > localCode;
}

export function resolveAppUpdateCheck(
  local: AppVersionInfo,
  remote: RemoteVersionManifest | null,
  fetchError?: string,
): AppUpdateCheckResult {
  if (!remote) {
    return { status: 'unknown', reason: fetchError ?? 'Manifesto de versión no disponible.' };
  }
  if (!isRemoteVersionNewer(remote.versionCode, local.versionCode)) {
    return { status: 'current' };
  }
  return {
    status: 'update_available',
    remote: { versionCode: remote.versionCode, versionName: remote.versionName },
    downloadUrl: remote.downloadUrl,
  };
}
